/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerManualRunFromScheduledAodRulesMutationResponse, TriggerManualRunFromScheduledAodRulesPathParams, TriggerManualRunFromScheduledAodRules400, TriggerManualRunFromScheduledAodRules404 } from "../models/TriggerManualRunFromScheduledAodRules";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { triggerManualRunFromScheduledAodRules } from "../axios/triggerManualRunFromScheduledAodRules";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const triggerManualRunFromScheduledAodRulesMutationKey = () => ["audit-reports-api", { url: '/aod-rules/scheduled-runs/:scheduledJobId/trigger' }] as const

export type TriggerManualRunFromScheduledAodRulesMutationKey = ReturnType<typeof triggerManualRunFromScheduledAodRulesMutationKey>

export function triggerManualRunFromScheduledAodRulesMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = triggerManualRunFromScheduledAodRulesMutationKey()
        return mutationOptions<TriggerManualRunFromScheduledAodRulesMutationResponse, ResponseErrorConfig<TriggerManualRunFromScheduledAodRules400 | TriggerManualRunFromScheduledAodRules404>, {scheduledJobId: TriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"]}, TContext>({
          mutationKey,
          mutationFn: async({ scheduledJobId }) => {
            return triggerManualRunFromScheduledAodRules(scheduledJobId, config)
          },
        })

}

/**
 * @description Triggers a manual AOD run based on an existing scheduled run configuration
 * @summary Trigger a manual AOD run based on a scheduled run
 * {@link /aod-rules/scheduled-runs/:scheduledJobId/trigger}
 */
export function useTriggerManualRunFromScheduledAodRules<TContext>(options: 
{
  mutation?: UseMutationOptions<TriggerManualRunFromScheduledAodRulesMutationResponse, ResponseErrorConfig<TriggerManualRunFromScheduledAodRules400 | TriggerManualRunFromScheduledAodRules404>, {scheduledJobId: TriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? triggerManualRunFromScheduledAodRulesMutationKey()

          const baseOptions = triggerManualRunFromScheduledAodRulesMutationOptions(config) as UseMutationOptions<TriggerManualRunFromScheduledAodRulesMutationResponse, ResponseErrorConfig<TriggerManualRunFromScheduledAodRules400 | TriggerManualRunFromScheduledAodRules404>, {scheduledJobId: TriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"]}, TContext>
          

          return useMutation<TriggerManualRunFromScheduledAodRulesMutationResponse, ResponseErrorConfig<TriggerManualRunFromScheduledAodRules400 | TriggerManualRunFromScheduledAodRules404>, {scheduledJobId: TriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TriggerManualRunFromScheduledAodRulesMutationResponse, ResponseErrorConfig<TriggerManualRunFromScheduledAodRules400 | TriggerManualRunFromScheduledAodRules404>, {scheduledJobId: TriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"]}, TContext>
      
}